import { memo, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

import { Dropdown, IconButton, Label, TextField } from 'basic-components'
import { Bin } from 'basic-components/icons'
import { DataLakeReadableConsts } from 'dashboard-services/api/dataLake'

import GroupValueResolver from './GroupValueResolver'

import './MetadataSet.scss'

const MetadataSet = ({ index, name = undefined, type = undefined, defaultValue = undefined, disabled = false, menuPortalTarget = undefined, onChange, onRemove, ref }) => {
  const defaultTypeObj = useMemo(() => DataLakeReadableConsts.GROUP_FIELD_TYPES.find(v => v.value === String(type).toLowerCase()), [type]),
        onChangeLocal = useCallback((value, { name }) => onChange(value, { name, index }), [onChange, index]),
        onRemoveLocal = useCallback(() => onRemove(index), [onRemove, index])

  return (
    <div
        className="data-lake__group-dialog__details__metadata-set"
        data-testid="group-dialog-metadata-set"
        ref={ref}
    >
      <div className="data-lake__group-dialog__details__metadata-set__header">
        <Label noError>Metadata set</Label>
        <IconButton
            className="data-lake__group-dialog__details__metadata-set__header__remove"
            data-testid="group-dialog-remove-metadata-set"
            disabled={disabled}
            onClick={onRemoveLocal}
            type="button"
        >
          <Bin
              color="blue-bright"
              height={16}
              width={16}
          />
        </IconButton>
      </div>
      <div className="data-lake__group-dialog__details__metadata-set__inputs">
        <Dropdown
            defaultValue={defaultTypeObj}
            disabled={disabled}
            menuPortalTarget={menuPortalTarget}
            name="type"
            onChange={onChangeLocal}
            options={DataLakeReadableConsts.GROUP_FIELD_TYPES}
            placeholder="Type"
            required
            variant="border"
        />
        <TextField
            defaultValue={name}
            disabled={disabled}
            name="name"
            onChange={onChangeLocal}
            placeholder="Name"
            required
            variant="border"
        />
        <GroupValueResolver
            defaultValue={defaultValue}
            disabled={disabled}
            menuPortalTarget={menuPortalTarget}
            onChange={onChangeLocal}
            type={type}
        />
      </div>
    </div>
  )
}

MetadataSet.displayName = "MetadataSet"

MetadataSet.propTypes = {
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  index: PropTypes.number.isRequired,
  menuPortalTarget: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  type: PropTypes.string
}

export default memo(MetadataSet)
